import './index.scss'
import LocomotiveScroll from 'locomotive-scroll'
import 'swiper/swiper.min.css'
import Swiper from 'swiper/swiper-bundle.min.js'

let ismobile = $(window).width() > 1024 ? false : true
let scroller

$(window).resize(function () {
	ismobile = $(window).width() > 1024 ? false : true;
})

$(document).ready(function () {
	let swiper1 = new Swiper('.section1 .big-img .swiper', {
		speed: 800,
		watchOverflow: true,
		effect : 'fade',
		fadeEffect: {
			crossFade: true,
		},
		autoplay: { // 自动切换
			delay: 3000,
			stopOnLastSlide: false,
			disableOnInteraction: false,
			waitForTransition: false,
		},
		on:{
			init: function(swiper){
				$('.section1 .small-img .swiper .swiper-slide').eq(this.realIndex).addClass('active')
			},
			slideChangeTransitionStart: function(){
				$('.section1 .small-img .swiper .swiper-slide').eq(this.realIndex).addClass('active').siblings().removeClass('active')
				swiper1_2.slideTo(this.realIndex)
			},
		}
	})
	let swiper1_2 = new Swiper('.section1 .small-img .swiper', {
		speed: 600,
		watchOverflow: true,
		centerInsufficientSlides: true,
		slidesPerView : 'auto',
	})
	$('.section1 .small-img .swiper .swiper-slide').on('click',function(){
		let index = $(this).index()
		swiper1.slideTo(index)
	})

	// section4 产品参数填充背景
	$('.section4 .progress').each(function () {
		var $this = $(this);
		var num = $this.data('num'); 
		$this.find('.progress-fill').css('width', num + '%'); 
	});
	const rlItemCount = $('.right_list .rl_item').length;
	$('.right_list .tips').toggleClass('width', rlItemCount % 2 === 0);
	// section5 表格部分开始
	var swiperNum = 0
	var swiper2 = new Swiper(".section5 .table-swiper .mySwiper", {
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		allowTouchMove: false,
		autoHeight: true,
		watchOverflow: true,
		on: {
			init: function (swiper) {
				swiperNum = this.realIndex
				$('.section5 .table-tab div').eq(this.realIndex).addClass('active')
			},
			slideChangeTransitionStart: function () {
				swiperNum = this.realIndex
				$('.section5 .table-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
			},
		}
	})
	$('.section5 .table-tab div').on('click', function () {
		$('.table-swiper .swiper-slide').find('table').removeClass('after').removeClass('before')
		let index = $(this).index()
		swiper2.slideTo(index)
		swiperNum = index
		updateTbodyScroll(index);
	})
	// 表格滑动
	function updateTbodyScroll(index) {
		// 获取对应索引的tbody  
		var $tbody = $('.table-swiper .swiper-slide').eq(index).find('tbody');

		// 解除之前的滚动事件处理程序（防止绑定多次）  
		$tbody.off('scroll');

		// 绑定新的滚动事件处理程序  
		$tbody.on('scroll', function () {
			var currentScrollTop = $(this).scrollTop();
			var maxScrollTop = $(this)[0].scrollHeight - $(this).outerHeight();

			if (currentScrollTop > 0) {
				$(this).closest('table').addClass('before');
			}

			if (currentScrollTop < maxScrollTop) {
				$(this).closest('table').addClass('after');
			}

			if (currentScrollTop <= 0) {
				$(this).closest('table').removeClass('before');
			}

			if (currentScrollTop >= maxScrollTop) {
				$(this).closest('table').removeClass('after');
			}
		});

		// 初始化滚动状态，确保在点击时立即更新状态  
		$tbody.scroll(); // 手动触发滚动检查  
	}
	updateTbodyScroll(swiperNum);
	// section5 表格部分结束
})
